import { useSelector } from 'react-redux'
import { useJackpotPrizeDistribution } from '@hooks/queries/useJackpot'
import { ordinalPosition } from '@core/jackpot/jackpotView'
import { JACKPOT_TABLE_HEADERS, JACKPOT_MESSAGES } from '@constants/jackpotConstants'
import JackpotTable from './JackpotTable'

const JackpotPrizesTab = ({ jackpotId }) => {
  const currencyCode = useSelector((state) => state.wallet.displayCurrencyCode)
  const { data, isPending, isError } = useJackpotPrizeDistribution({ jackpotId })
  const rows = data?.rows ?? []

  return (
    <JackpotTable
      headers={JACKPOT_TABLE_HEADERS.PRIZES}
      rows={rows}
      isPending={isPending}
      isError={isError}
      emptyMessage={JACKPOT_MESSAGES.NO_PRIZES}
      currencyCode={currencyCode}
      medalRows
      renderRow={(row, index) => (
        <div key={row.position ?? index} className="standard-normal-jackpot-table-row">
          <div className="standard-normal-jackpot-table-cell standard-normal-jackpot-table-cell-position">
            {ordinalPosition(row.position)}
          </div>
          <div className="standard-normal-jackpot-table-cell standard-normal-jackpot-table-cell-reward">
            {currencyCode} {row.reward}
          </div>
        </div>
      )}
    />
  )
}

export default JackpotPrizesTab
